<template>
  <modal-base :is-open="isOpen">
    <div
      class="closeLayer"
      @click="emit('cancel')"
    ></div>
    <div class="c-popup-body -alert">
      <div class="c-popup-body__inner">
        <div class="c-popup-body__main">
          <div class="alertBlock">
            <div :class="{'text': true, '-center': isCenter}">
              <slot>よろしいですか？</slot>
            </div>
            <div class="button-area c-button -col2">
              <a
                href="javascript:void(0);"
                class="c-button-blue -alert"
                @click="emit('ok')"
              >
              <span class="label">{{ okLabel }}</span>
              </a>
              <a
                href="javascript:void(0);"
                class="c-button-white -cancel"
                @click="emit('cancel')"
              >
                <span class="label">キャンセル</span>
              </a>
            </div>
          </div>
        </div>
        <span
          class="c-popup-body__close"
          @click="emit('cancel')"
        >
          <span class="c-popup-body__close-inner"></span>
        </span>
      </div>
    </div>
  </modal-base>
</template>

<script setup lang="ts">
  withDefaults(
    defineProps<{
      isOpen?: boolean;
      isCenter?: boolean;
      okLabel?: string;
    }>(),
    {
      isOpen: false,
      isCenter: true,
      okLabel: "OK"
    }
  )
  const emit = defineEmits<{
    (e: 'ok'): void,
    (e: 'cancel'): void,
  }>()
</script>

<style lang="scss" scoped>
</style>
